import { useQuery } from "react-query"
import DataRequest from '../queries/DataRequest'
import {GetPhotosResponse} from "../types/responses/GetPhotosResponse";

export const getPhotos = (inspectionId: string) => {
    return useQuery<GetPhotosResponse[]>("vesselPhotos", async () => {
        return await DataRequest(inspectionId,"photos");
    }, { staleTime: process.env.REACT_APP_API_STALETIME as number | undefined });
}
